export const TipoOperacionPedimentoEnum = {
    Importacion: "1",
    Exportacion: "2",
    CTM: "3",
    Destruccion: "4",
};

export const tipoOperacionPedimento = [
    {
        clave: TipoOperacionPedimentoEnum.Importacion,
        descripcion: "Importación",
    },
    {
        clave: TipoOperacionPedimentoEnum.Exportacion,
        descripcion: "Exportación",
    },
    {
        clave: TipoOperacionPedimentoEnum.CTM,
        descripcion: "CTM",
    },
    {
        clave: TipoOperacionPedimentoEnum.Destruccion,
        descripcion: "Destrucción",
    },
];
